import { Button } from "@/components/ui/atoms/Button/Button";

export type ButtonGroupProps = {
  className?: string;
  options: { label: string, value: string }[];
  onChange: (value: string) => void;
  value: string;
}

const ButtonGroup = ({ onChange, options, value, className }: ButtonGroupProps): JSX.Element => {
  return (
    <div className={`flex flex-wrap flex-row gap-1w ${className}`}>
      { options.map(option => (
        <Button
          type="button"
          onClick={() => onChange(option.value)} 
          key={option.value}
          variant={option.value === value ? 'default' : 'secondary'}>
            {option.label}
        </Button>)) }
    </div>
  );
}

export default ButtonGroup;